// @vendors
import React, { useContext } from 'react'
import { Menu, MenuItem } from '@mui/material'
import { Link  } from "react-router-dom";

// @constants
import { ROUTENAME } from '../../../../navigation/RouteName'
import { EmployeeContext } from '../../Employer';
import { theme } from '../../../../assets/theme';

const MenuAddBranch = ({anchorElMenu, openMenu, handleCloseMenu}) => {
    const {employerDetails} = useContext(EmployeeContext);
    const parentId = employerDetails?.data?.id;

  return (
    <Menu
        id="basic-menu"
        anchorEl={anchorElMenu}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          component={Link}
          to={{
              pathname: `${ROUTENAME.createEmployer}`,
              state: {parentCompanyId: parentId, data: employerDetails?.data },
          }}
          sx={{ color: theme.palette.primary.black }}
        >
          Copy from Parent
        </MenuItem>
        <MenuItem
          component={Link}
          to={{
              pathname: `${ROUTENAME.createEmployer}`,
              state: {parentCompanyId: parentId, data: {} },
          }}
          sx={{ color: theme.palette.primary.black }}
        >
          From Scratch
        </MenuItem>
      </Menu>
  )
}

export default MenuAddBranch